import { AuthorizedService } from "./index";

export const PluginService = url => AuthorizedService(url);